import { BaseDto } from './base.dto';

export enum AlarmRuleConditionType {
  LAST_ACTIVITY = 'lastActivity',
  HAS_ALARM_CHECK = 'hasAlarmCheck',
  COMPARISON = 'comparison',
}

export type ConditionOperator = 'AND' | 'OR';

export interface AlarmRuleConditionDto extends BaseDto {
  alarm_rule_id: number;
  type: AlarmRuleConditionType;
  config: string | Record<string, unknown> | AlarmRuleConditionOfflineConfig | AlarmRuleConditionHasAlarmCheckTypeConfig | AlarmRuleComparisonRuleConfig;
  overrideConfig?: Record<string, unknown>;
  sort_index: number;
  operator: ConditionOperator;
}

/*
 * Offline Type Entity
 */
export interface AlarmRuleConditionOfflineConfig {
  hour: number;
}

/*
 * AlarmType
 */
export interface AlarmRuleConditionHasAlarmCheckTypeConfig {
  exists: boolean;
  alarmType?: string;
}

/*
 * Comparison
 */
export interface AlarmRuleComparisonRuleConfig {
  operator: ComparisonOperator;

  left?: AlarmRuleComparisonSideConfig
  right?: AlarmRuleComparisonSideConfig
}

export interface AlarmRuleComparisonSideConfig {
  source_type: ComparisonValueSourceType;
  measurement_variable?: string;
  fixed_value?: number;
  range_hours?: number;
  value_count?: number;
}

export type ComparisonSourceSide = 'left' | 'right';
export enum ComparisonValueSourceType {
  CURRENT_VALUE = 'current_value',
  FIXED_VALUE = 'fixed_value',
  HISTORICAL_VALUE = 'historical_value',
  DELTA_VALUE = 'delta_value',
  TIME_RANGE_SUM = 'time_range_sum',
  LAST_N_VALUES_SUM = 'last_n_values_sum',
  LAST_N_VALUES_AVG = 'last_n_values_avg',
  LAST_N_VALUES_MIN = 'last_n_values_min',
  LAST_N_VALUES_MAX = 'last_n_values_max'
}

export type ComparisonOperator =
  | 'lt'
  | 'lte'
  | 'gt'
  | 'gte'
  | 'eq'
  | 'neq';

export interface AlarmRuleConditionUpdateDto {
  id?: number;
  type: AlarmRuleConditionType;
  config: {} | AlarmRuleConditionOfflineConfig | AlarmRuleConditionHasAlarmCheckTypeConfig | AlarmRuleComparisonRuleConfig;
  sort_index: number;
  operator: ConditionOperator;
}